<template>
  <div class="layout">
    <div class="layout_nav">
      <!-- navegacion  -->
      <Nav v-bind="getRol"></Nav>
    </div>
    <div class="layout_center">
      <!-- tabla de datos -->
      <div>
        <v-card-title>
          <v-row>
            <v-col cols="auto" sm="auto" md="auto">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" icon dark v-bind="attrs" v-on="on" style="top:0;">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn class="on_line" plain @click="readAll()">
                        Marcar todos como leídas
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col cols="auto" sm="auto" md="auto">
              <h2 class="text-h5">Notificaciones</h2>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
          <v-row justify="end">
            <v-col cols="12" sm="12" md="4">
              <v-combobox
                v-if="isMaster"
                ref="company"
                v-model="company"
                :items="itemsDataCompany"
                :search-input.sync="searchCompany"
                item-value="_id"
                item-text="name"
                placeholder="filtrar empresa"
                clearable
              ></v-combobox>
            </v-col>
            <v-col cols="12" sm="12" md="5">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="auto" sm="12" md="auto" class="pt-7">
              <v-btn-toggle v-model="toggleFilters">
                <v-btn
                class="ma-2"
                small
                outlined
                >
                  <v-icon
                    left
                    dark
                  >
                    mdi-filter
                  </v-icon>
                  Filtros
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </v-card-title>
        <transition name="fade" v-if="toggleFilters == 0">
          <v-card-subtitle>
            <v-row justify="center">
              <v-col cols="12" sm="12" md="auto">
                <v-combobox
                  label="Evento"
                  v-model="selectEvent"
                  :items="itemsEvents"
                  clearable
                ></v-combobox>
              </v-col>
              <v-col cols="12" sm="12" md="auto">
                <v-menu
                  v-model="datePicker1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="date-init"
                      v-model="dateIni"
                      label="Fecha Inicial"
                      prepend-icon="mdi-calendar"
                      clearable
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="date-init"
                    v-model="dateIni"
                    :max="new Date().toISOString().substr(0, 10)"
                    @input="datePicker1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="12" md="auto">
                <v-menu
                  v-model="datePicker2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      ref="date-dateEnd"
                      v-model="dateEnd"
                      label="Fecha Final"
                      prepend-icon="mdi-calendar"
                      clearable
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="date-dateEnd"
                    v-model="dateEnd"
                    :min="new Date(dateIni).toISOString().substr(0, 10)"
                    :max="new Date().toISOString().substr(0, 10)"
                    @input="datePicker2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-card-subtitle>
        </transition>
        <v-data-table
          v-bind:headers="headers"
          v-bind:items="itemsData"
          :loading="loadingInfo"
          :footer-props="{
            'items-per-page-options': [10],
          }"
          :sort-by="['updateAt']"
          :sort-desc="[true]"
          :items-per-page="10"
          :server-items-length="totalNumberOfItems"
          :options.sync="pagination"
          :search="search"
          :item-class="itemClass"
          loading-text="Cargando información …."
          class="elevation-1"
        >
          <template v-slot:[`item.check`]="{ item }">
            <v-icon v-if="item.check === true" x-small color="primary">mdi-checkbox-blank-circle</v-icon>
          </template>
          <template v-slot:[`item.register`]="{ item }">
            <div class="pt-3">
              <p v-html="item.register"></p>
            </div>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ item.date | formatDateFrom }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div v-if="item.check === true">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="table_menu"
                    color="primary"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item class="list_action">
                    <v-btn plain @click="editItem(item)">
                      <span>Marcar leido</span>
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div v-else>
              <span class="disable-text">Ninguna</span>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Nav from "@/components/Nav.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "NotifyHome",
  components: {
    Nav,
  },
  data() {
    return {
      newFlag: false,
      search: "",
      itemsData: [],
      totalItems: 0,
      dateIni: null,
      dateEnd: null,
      datePicker1: false,
      datePicker2: false,
      toggleFilters: null,
      page: 0,
      totalNumberOfItems: 0,
      pagination: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      itemObjct: {},
      searchCompany: "",
      company: null,
      itemsDataCompany: [],
      totalNumberOfItemsComp: 0,
      loadingInfo: false,
      paginationc: {
        page: +this.$route.query.page || 1,
        itemsPerPage: 10,
      },
      itemsEvents: [
        'Limite caudal',
        'Lectura Masiva',
        'Lectura Individual',
        'Limite',
        'Programado',
      ],
      selectEvent: null,
      headers: [
        {
          text: "",
          value: "check",
          width: "1%"
        },
        {
          text: "_id",
          value: "_id",
          align: " d-none",
        },
        {
          text: "NUI",
          value: "device.nui",
        },
        {
          text: "IDX",
          value: "device.idx",
        },
        {
          text: "Mensaje",
          value: "register",
          width: "40%",
        },
        {
          text: "Evento",
          value: "action",
        },
        {
          text: "Empresa",
          value: "company.name",
        },
        {
          text: "Fecha",
          value: "date",
        },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
  async mounted() {
    //await this.listCompany();
    this.getJsonData();
    this.$root.$on("reload", async () => {
      await this.getJsonData();
    });
    //await this.listDevice();
  },
  watch: {
    searchCompany: {
      handler() {
        this.getJsonCompany().then((data) => {
          this.itemsDataCompany = data.docs;
        });
        this.pagination.page = 0;
        this.getJsonData();
      },
      deep: true,
    },
    search: {
      handler() {
        this.pagination.page = 0;
        this.getJsonData();
      },
      deep: true,
    },
    pagination: {
      handler() {
        this.getJsonData();
      },
      deep: true,
    },
    selectEvent: {
      handler() {
        this.pagination.page = 0;
        this.getJsonData();
      },
      deep: true,
    },
    dateIni: {
      handler() {
        this.pagination.page = 0;
        this.getJsonData();
      },
      deep: true,
    },
    dateEnd: {
      handler() {
        this.pagination.page = 0;
        this.getJsonData();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["updateNotify", "updateNotifyAll"]),
    actionTableNull() {
      setTimeout(() => {
        return false;
      }, 2000);
    },
    async readAll() {
      await this.updateNotifyAll();
      await this.getJsonData();
      /* this.$root.$on("reload", async () => {
      }); */
    },
    async getJsonCompany() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)

          axios
            .get(
              `company/list?page=${this.paginationc.page}&search=${this.searchCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              //console.log('company', res.data)
              this.itemsDataCompany = res.data.docs;
              this.totalNumberOfItemsComp = res.data.totalDocs;
              resolve(res.data);
            })
            .catch((error) => {
              //console.log(error.response.status)
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany = this.company != null ? this.company._id : null;
          let search = `&search=${this.search}`;
          if(idCompany != null) search += `&company=${idCompany}`;
          if(this.selectEvent != null) search += `&action=${this.selectEvent}`;
          if(this.dateIni != null) search += `&initDate=${this.dateIni}`;
          if(this.dateEnd != null) search += `&endDate=${this.dateEnd}`;
          this.loadingInfo = true;

          axios
            .get(
              `notify/list?page=${this.pagination.page}${search}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.itemsData = res.data.docs;
              this.totalNumberOfItems = res.data.totalDocs;
              this.loadingInfo = false;
              resolve(res.data);
            })
            .catch((error) => {
              this.loadingInfo = false;
              reject(error.response.status);
            });
        });
      } catch (error) {
        this.loadingInfo = false;
        throw new Error(error.response.data);
      }
    },
    async editItem(param) {
      //this.$root.$emit('reload')
      let send = {
        //device: param.device,
        _id: param._id,
        check: false,
      };
      let respo = await this.updateNotify(send);
      this.$root.$emit("reload");
      if (respo == 200) {
        this.getJsonData();
      } else {
        //console.log('error')
      }
    },
    itemClass(item) {
      return item.check == false ? "notify_checked" : "";
    }
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "getNotifyDevice",
      "getListDevice",
      "getUser",
      "getRol",
      "isMaster",
    ]),
    loadBar() {
      if (this.itemsData.length > 0) {
        return false;
      } else {
        return true;
      }
    },
  },
  filters: {
    formatDateFrom: (value) => {
      if (value) {
        return moment(value)
          .locale("es")
          .fromNow();
      }
      return "-";
    },
    formatDate: (value) => {
      if (value) {
        return moment(value)
          .locale("es")
          .format("LLL");
      }
      return "-";
    },
  },
};
</script>
<style lang="scss">
span.disable-text {
  color: #ddd;
}
.notify_checked {
  background-color: #f7f7f7;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}
</style>
